import React from 'react';
import { cn } from '@/lib/utils';
import { paletteFor } from '@/helpers/breakdown-palette.helper';
export function ShareBar({ share, rank }) {
    const width = Math.min(100, Math.max(0, share));
    const tint = typeof rank === 'number' ? paletteFor(rank) : 'bg-foreground/40';
    return (<div className="flex items-center justify-end gap-2">
            <div className="relative h-2 w-24 rounded-full bg-muted overflow-hidden">
                <div className={cn('absolute left-0 top-0 h-full rounded-full', tint)} style={{ width: `${width}%` }}/>
            </div>
            <span className="w-12 text-right tabular-nums">{share}%</span>
        </div>);
}
